'use strict';

require('helpers/helper');
import 'babel-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { useRouterHistory } from 'react-router'
import { createHistory } from 'history';
import routes from 'routes';
import configureStore from 'store/configureStore';
import Root from './root.container';
import clrSso from 'clarity-ui-sso';
import config from 'config';

const historyConfig = process.env;
const history = useRouterHistory(createHistory)(historyConfig);

clrSso.init();
clrSso.startup(config.loginOptions);

const initialState = {
    db: {
      // Fetching database code.
      isFetching: false,
      // Stores the error status per result.
      errors: {},
      // Stores the entities from the database.
      entities: {},
      // Stores the return results from the server.
      result: {}
    }
  };

const store = configureStore({ initialState, history });

// Render the React application to the DOM
ReactDOM.render(
  <Root history={history} routes={routes} store={store} />,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/components/run.container.jsx